import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const ANDROID_GREEN = '#3DDC84';

const OtaPlatformIcon = ({ platform, size = 22 }) => {
  const normalized = String(platform || '').toLowerCase();

  if (normalized === 'ios') {
    return (
      <Tooltip title={I18n.t('AdminOtaScene.Updates.platformFilters.ios')}>
        <Box
          component="span"
          aria-label={I18n.t('AdminOtaScene.Updates.platformFilters.ios')}
          sx={{ display: 'inline-flex', alignItems: 'center', color: '#000', alignSelf: 'center' }}
        >
          <AppleIcon sx={{ fontSize: size }} />
        </Box>
      </Tooltip>
    );
  }

  if (normalized === 'android') {
    return (
      <Tooltip title={I18n.t('AdminOtaScene.Updates.platformFilters.android')}>
        <Box
          component="span"
          aria-label={I18n.t('AdminOtaScene.Updates.platformFilters.android')}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            color: ANDROID_GREEN,
            alignSelf: 'center',
          }}
        >
          <AndroidIcon sx={{ fontSize: size }} />
        </Box>
      </Tooltip>
    );
  }

  return platform || '—';
};

OtaPlatformIcon.propTypes = {
  platform: PropTypes.string,
  size: PropTypes.number,
};

export default OtaPlatformIcon;
